import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { FaInstagram, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

/* == tiny hooks ==================================================== */
const useLockBodyScroll = (active) => {
  useEffect(() => {
    const styleId = "trainer-scroll-lock";

    if (active) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `body { overflow: hidden !important; }`;
      document.head.appendChild(style);
    }

    return () => {
      const style = document.getElementById(styleId);
      if (style) style.remove();
    };
  }, [active]);
};



const useEscape = (onClose, active) => {
  useEffect(() => {
    if (!active) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keyup", onKey);
    return () => window.removeEventListener("keyup", onKey);
  }, [active, onClose]);
};

/* == component ===================================================== */
export default function TrainerModal({ trainer, labels, name, bio, onClose }) {
  const modalRoot = typeof window !== "undefined" ? document.body : null;
  useLockBodyScroll(Boolean(trainer));
  useEscape(onClose, Boolean(trainer));

  const closeBtnRef = useRef(null);
  useEffect(() => {
    if (trainer) closeBtnRef.current?.focus();
  }, [trainer]);

  if (!trainer || !modalRoot) return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      className="trainer-lightbox"
      onClick={onClose}
    >
      <div
        className="trainer-lightbox-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={closeBtnRef}
          aria-label="Close"
          className="trainer-lightbox-close"
          onClick={onClose}
        >
          &times;
        </button>

        {/* ───── ROW 1 : image + text ───── */}
        <div className="content-main">
          <div className="img-wrapper">
            <img
              className="lightbox-img"
              src={trainer.img}
              alt={name(trainer.key)}
            />
          </div>

          <div className="lightbox-text">
            <h2>{name(trainer.key)}</h2>
            <p className="lightbox-bio">{bio(trainer.key)}</p>
          </div>
        </div>

        {/* ───── ROW 2 : contact icons ───── */}
        <div className="lightbox-contact">
          {trainer.phone && (
            <a
              className="contact-link"
              href={`tel:${trainer.phone.replace(/\s+/g, "")}`}
              aria-label={labels("phone")}
            >
              <FaPhoneAlt />
            </a>
          )}

          {trainer.mail && (
            <a
              className="contact-link"
              href={trainer.mail}
              aria-label={labels("email")}
            >
              <FaEnvelope />
            </a>
          )}

          {trainer.insta && (
            <a
              className="contact-link"
              href={trainer.insta}
              rel="noopener noreferrer"
              target="_blank"
              aria-label={labels("instagram")}
            >
              <FaInstagram />
            </a>
          )}
        </div>
      </div>
    </div>,
    modalRoot
  );
}
